module.exports = __webpack_public_path__ + "img/headset.74ffabb5.png";